<template>
  <div class="participant-response-query pl-16 pr-16 pt-16">
    <div class="participant-response-query__time-id-container d-flex justify-content-between">
      <span class="participant-response-query__time">{{ query.created_time | formatGMTDate }}</span>
      <span class="participant-response-query__query-id">ID: {{ query.id | slice5 }}</span>
    </div>
    <div class="participant-response-query__name">
      {{ query.issuer | uppercase }}
    </div>
    <div class="participant-response-query__text mt-6 fs-14 mb-22">
      {{ query.query_content }}
    </div>
    <div class="participant-response-query__link-container mb-11">
      <span class="participant-response-query__view-link" @click="displayDetailedView">View</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "participant-activity-response-query-item",
  props: {
    query: {
      type: Object
    }
  },

  filters: {
    slice5(val) {
      return val.slice(0, 5);
    }
  },

  methods: {
    displayDetailedView() {
      this.$emit("displayDetailedView", this.query);
    }
  }
};
</script>

<style lang="scss" scoped>
.participant-response-query {
  border-bottom: 1px solid #efefef;

  &__time-id-container {
    color: #959fa4;
    font-size: 11px;
  }

  &__name {
    color: #b0bac9;
    font-size: 10px;
  }

  &__text {
    color: #000000;
  }

  &__view-link {
    width: 31px;
    height: 14px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #4c8ce4;
    cursor: pointer;
  }

  &-detailed-reply-btn {
    width: 83.9px;
    height: 23.9px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4c8ce4;
  }
}
</style>
